import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ModalService} from "../../services/modal.service";
import {APP_MESSAGES} from "../../enums/enums";
import {NvHistoryJournalComponent} from "../../components/nv-history-journal/nv-history-journal.component";

declare const $: any;

@Component({
  selector: 'app-nv-history-journal-modal',
  templateUrl: './nv-history-journal-modal.component.html',
  styles: []
})
export class NvHistoryJournalModalComponent implements OnInit {

  @ViewChild("modalRoot") element: ElementRef;
  @ViewChild("journal") journal: NvHistoryJournalComponent;
  constructor(private modalService:ModalService) { }

  ngOnInit() {
    this.modalService
      .onModalRequest
      .filter(appMessage => appMessage.type === APP_MESSAGES.POPUP_HISTORY_JOURNAL)
      .subscribe(appMessage => this.show(appMessage.content));
  }

  private show(content:any){
    //console.log(this.journal);
    $(this.element.nativeElement).modal();
    this.journal.loadList();
    //$(this.journal.nativeElement).loadList();
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/modals/nv-history-journal-modal/nv-history-journal-modal.component.ts